import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { MdbRippleModule } from 'src/lib/mdb5-adapted/public-api';

import { AppUtilityService } from '../app-utility.service';
import { LmsModalFrameComponent } from '@lmsSharedUI';

@Component({
  selector: 'app-offer-values',
  templateUrl: './offer-values.component.html',
  styleUrls: ['./offer-values.component.scss'],
  standalone: true,
  imports: [CommonModule, LmsModalFrameComponent, MdbRippleModule],
})
export class OfferValuesComponent implements OnInit {
  compuscanOffers: any[] = [];
  selectedRowIndex: any;
  withOverride = false;
  constructor(
    public modalRef: MdbModalRef<OfferValuesComponent>,
    public global_utility: AppUtilityService
  ) {}

  ngOnInit(): void {
    this.compuscanOffers.sort((a,b)=> a.id-b.id);
  }

  overrideOffer(data: any) {
    if(this.compuscanOffers && this.withOverride === true) {
      if (this.selectedRowIndex === data && (data.overrideApplied === true || data.overrideRequested === true)) {
        this.global_utility.info('Selected offer override not available!');
        return;
      }

      this.selectedRowIndex = data;
      for (const offer of this.compuscanOffers) {
        if (offer.id <= data.id && (offer.outcome === 'N' || offer.outcome === 'Decline' || offer.outcome === 'Refer')) {
          offer.overrideRequested = true;
          offer.requestedBy = this.global_utility.getGlobalData('userDisplay');
        }
      }

      this.modalRef.close(this.compuscanOffers);
    }
  }

  close() {
    this.modalRef.close();
  }
}
